import React, { useCallback, useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { format } from 'date-fns';
import MaterialLink from '@material-ui/core/Link';
import styled from 'styled-components';
import { Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PhoneIcon from '@material-ui/icons/Phone';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import { IUser } from 'src/interface';
import { useAuthentication } from 'src/contexts/auth/auth.context';
import CardItem from '../../Common/card';

type StyledProps = {
  phoneNumber?: boolean;
};
const MemberInfoBox = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 0 30px;
`;
const MemberInfo = styled('div')`
  margin-left: 10px;
`;
const MemberName = styled('div')``;
const MemberSince = styled(Typography)`
  display: block;
  font-size: 12px !important;
  line-height: 20px !important;

  padding: 0 0 15px;
`;
const SeeAllAds = styled(MaterialLink)`
  font-size: 14px !important;
  line-height: 14px !important;
`;
const AvatarStyled = styled(Avatar)`
  width: 50px !important;
  height: 50px !important;
  img {
    object-fit: cover;
  }
`;

const CardItemStyled = withStyles({
  root: {
    background: 'red',
  },
})(CardItem);

const SellerNameLink = styled(MaterialLink)`
  margin: 0 0 2px;
  font-size: 20px;
  line-height: 23px;
`;
const SellerPhoneButton = styled(Button)`
  display: flex !important;
  width: 90%;
  align-items: center !important;
  color: #fff !important;
  position: relative !important;
  border-radius: 10px !important;
  margin: 10px 0 !important;
  background: ${({ theme }) => theme.colors.primary} !important;
`;
const SellerPhoneContent = styled('span')<StyledProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: left;
  padding: 15px 15px 15px 0;
  h4 {
    margin: 0;
    font-size: 20px;
    line-height: 20px;
    padding: ${({ phoneNumber }) => (phoneNumber && '0px') || '0 0 6px'};
  }
  span {
    font-size: 14px;
    line-height: 14px;
  }
`;
const MakeOfferButton = styled(SellerPhoneButton)`
  background: ${({ theme }) => theme.colors.secondary} !important;
`;
const MakeOfferContent = styled(SellerPhoneContent)`
  a {
    color: white !important;
  }
`;
const StyledPhoneIcon = withStyles({
  root: {
    fontSize: '30px',
    flexBasis: '20%',
  },
})(PhoneIcon);
const StyledBusinessCenterIcon = withStyles({
  root: {
    fontSize: '30px',
    flexBasis: '20%',
  },
})(BusinessCenterIcon);

type TProps = {
  context: string;
  user: IUser;
  showLinkToAllAds?: boolean;
};
const UserDetailsPanel = ({ user, context, showLinkToAllAds }: TProps) => {
  const [authState, dispatchToAuth] = useAuthentication();
  const { isAuthenticated } = authState;
  const [showAuthContent, setShowAuthContent] = useState<boolean>(false);

  const { first_name, last_name } = user;

  const handleAuthContent = useCallback(() => {
    if (isAuthenticated) {
      setShowAuthContent(true);
    } else {
      dispatchToAuth({ type: 'SWITCH_AUTH_MODAL', payload: true });
    }
  }, [setShowAuthContent, isAuthenticated, dispatchToAuth]);

  return (
    <CardItemStyled title="Seller Contact Detail">
      <MemberInfoBox>
        <AvatarStyled alt={user.first_name}>
          {(user.image &&
            user.image.includes('graph.facebook.com') &&
            user.image.includes('assets-rentable.sgp1.digitaloceanspaces.com') && (
              <Image src={user.image} width={50} height={50} alt={`${first_name} ${last_name}`} />
            )) ||
            (user.image && <img src={user.image} alt={user.first_name} />)}
        </AvatarStyled>
        <MemberInfo>
          <MemberName>
            <Link href="/user-listings/[id]" as={`/user-listings/${user.id}`} prefetch={false}>
              <SellerNameLink>{`${first_name} ${last_name}`}</SellerNameLink>
            </Link>
          </MemberName>
          <MemberSince variant="h6">
            Member Since {format(new Date(user.created_at), 'MMM dd yyyy')}
          </MemberSince>
          {showLinkToAllAds && (
            <Link href="/user-listings/[id]" as={`/user-listings/${user.id}`} prefetch={false}>
              <SeeAllAds>See all Ads</SeeAllAds>
            </Link>
          )}
        </MemberInfo>
      </MemberInfoBox>
      <SellerPhoneButton>
        <StyledPhoneIcon />
        <SellerPhoneContent onClick={handleAuthContent} phoneNumber={showAuthContent}>
          {(showAuthContent && <h4>{user.phone_number}</h4>) || (
            <>
              <h4>Show Phone No.</h4>
              <span>Click To Show Number</span>
            </>
          )}
        </SellerPhoneContent>
      </SellerPhoneButton>
      <MakeOfferButton>
        <StyledBusinessCenterIcon />
        <MakeOfferContent>
          <MaterialLink
            underline="none"
            href={
              (isAuthenticated &&
                `mailto:${user.email}?subject=${context}!&body=Hello ${user.email},`) ||
              '#'
            }
            onClick={() => {
              if (!isAuthenticated) {
                handleAuthContent();
              }
            }}
          >
            <h4>Contact</h4>
            <span>Place Your Best Offer Now</span>
          </MaterialLink>
        </MakeOfferContent>
      </MakeOfferButton>
    </CardItemStyled>
  );
};

export default UserDetailsPanel;
